export function useSessionStorage(store, key) {
  cleanUpStorage(key);
  const json = sessionStorage.getItem(key);
  if (json && json !== "undefined") {
    store.set(JSON.parse(json));
  }

  store.subscribe(value => {
    sessionStorage.setItem(key, JSON.stringify(value));
  });
}

export function useLocalStorage(store, key) {
  const json = localStorage.getItem(key);
  if (json && json !== "undefined") {
    store.set(JSON.parse(json));
  }

  store.subscribe(value => {
    localStorage.setItem(key, JSON.stringify(value));
  });
}

function cleanUpStorage(key) {
  const items = { ...sessionStorage };
  if (!items[key] || items[key] == "undefined") {
    return;
  }
  let s = JSON.parse(items[key]);
  let value = JSON.parse(items[key]);
  for (let [k, v] of Object.entries(s)) {
    if (v.hasOwnProperty("expiry")) {
      let d = new Date();
      if (v.expiry < d.getTime()) {
        console.log(`Expiring ` + k);
        delete(value[k]);
      }
    }
  }
  sessionStorage.setItem(key, JSON.stringify(value));
}

